import { render, staticRenderFns } from "./BottomDialog.vue?vue&type=template&id=0bd2475e&scoped=true&"
import script from "./BottomDialog.vue?vue&type=script&lang=ts&"
export * from "./BottomDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BottomDialog.vue?vue&type=style&index=0&id=0bd2475e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2475e",
  null
  
)

export default component.exports